// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style_buttons__2CwaL","buttonStyleLandingPage":"style_buttonStyleLandingPage__2AaGu","description":"style_description__3nj6s"};